import { LANGUAGE } from '../../constants';

const card = (data, solution) => `<div class="card-gray mb-sm-5 mb-4">
<div class="row">
  <div class="col-12 col-lg-7 pad-card pb-sm-4 pb-3">
    <h3 id="section-1-block-0-title">${data.title}</h3>
    <p>
      ${data.summary}
    </p>
    <a href="/soluciones/solution/?case=${data.name}" class="btn btn-primary" style="margin: 1rem 0">
      <span id="section-1-2-button">${solution}</span>
    </a>
  </div>
  <div class="col-12 col-lg-5 position-relative">
    <img loading="lazy" class="image-fill" src="/assets/img/usecases/solutions/card/${data.summary_img}.webp" />
  </div>
</div>
</div>`;

const language = window['__PRERENDER_INJECTED'] ? window['__PRERENDER_INJECTED'].language : LANGUAGE;
const solution = language === 'en' ? 'Read more' : 'Ver solución';

// function formatText(stringWithPlaceholders, replacements) {
//   return stringWithPlaceholders.replace(/{(\w+)}/g, (placeholderWithDelimiters, placeholderWithoutDelimiters) =>
//     replacements.hasOwnProperty(placeholderWithoutDelimiters)
//       ? replacements[placeholderWithoutDelimiters]
//       : placeholderWithDelimiters
//   );
// }

class SolutionPreview extends HTMLElement {
  set content(data) {
    this.setAttribute('content', data);
  }
  get content() {
    return this.hasAttribute('content');
  }
  static get observedAttributes() {
    return ['content'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (
      DEVELOPMENT ||
      (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].render_text) ||
      this.getAttribute('dynamic') === 'true'
    ) {
      switch (name) {
        case 'content':
          this.render(newValue);
          break;
      }
    }
  }

  render(data) {
    const parsedData = JSON.parse(data);
    this.innerHTML = '';
    parsedData.forEach((story) => {
      this.innerHTML += card(story.content, solution);
    });
  }

  connectedCallback() {
    if (DEVELOPMENT || (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].render_text)) {
      this.innerHTML = '';
    }
  }
}

customElements.define('custom-solution-preview', SolutionPreview);
